/* Auswahl-Leiste für Produkte mit Varianten – snippets/cart-icon-button.liquid
   Öffnet/schließt das <dialog> und zeigt die gewählte Variante im Fußbereich.
   Das Hinzufügen übernimmt <product-form> (product-form.js), danach öffnet sich der Warenkorb. */

if (!customElements.get('cart-variant-picker')) {
  customElements.define(
    'cart-variant-picker',
    class CartVariantPicker extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[aria-haspopup="dialog"]');
        if (!this.dialog || !this.opener) return;

        this.opener.addEventListener('click', () => this.open());

        // Schließen über X oder Klick auf den abgedunkelten Hintergrund
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog || event.target.closest('[data-close]')) this.close();
        });

        // Scroll-Sperre aufheben (auch bei Esc). Nicht beim Übergang in die Warenkorb-Leiste:
        // Das close-Event kommt verzögert und würde sonst die Sperre des Warenkorbs entfernen
        // → Scrollleiste blitzt auf, die Seite "zieht sich ein".
        this.dialog.addEventListener('close', () => {
          if (this.handingOverToCart) {
            this.handingOverToCart = false;
            return;
          }
          if (!document.querySelector('cart-drawer.active')) {
            document.body.classList.remove('overflow-hidden');
          }
        });

        // Gewählte Variante + Preis im Fußbereich anzeigen
        this.dialog.addEventListener('change', (event) => {
          if (event.target.name === 'id') this.updateSummary(event.target);
        });

        // Nach erfolgreichem Hinzufügen schließen, damit die Warenkorb-Leiste übernimmt
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
            if (!this.dialog.open) return;
            // Warenkorb-Leiste öffnet direkt danach und braucht die Scroll-Sperre weiterhin
            this.handingOverToCart = !!document.querySelector('cart-drawer');
            this.close();
          });
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        this.initialized = false;
      }

      open() {
        // product-form.js aktiviert beim Start das erste [name=id] – ausverkaufte Varianten wieder sperren
        this.dialog.querySelectorAll('input[data-unavailable]').forEach((input) => {
          input.disabled = true;
        });
        document.body.classList.add('overflow-hidden');
        this.dialog.showModal();
      }

      close() {
        this.dialog.close();
      }

      updateSummary(input) {
        const option = input.closest('.cart-variant-dialog__option');
        const title = this.dialog.querySelector('[data-selected-title]');
        const price = this.dialog.querySelector('[data-selected-price]');
        if (!option) return;
        if (title) title.textContent = option.querySelector('.cart-variant-dialog__option-title').textContent;
        if (price) price.innerHTML = option.querySelector('.cart-variant-dialog__option-price').innerHTML;
      }
    }
  );
}
